import React from 'react';
import { connect } from 'react-redux';
import { deleteRombel } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Icon from '@mdi/react';
import { mdiShieldHalfFull } from '@mdi/js';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteRombel,
};

function ModalDeleteItem({ data, closeModal, deleteRombel }) {
  const auth = data.auth;
  const history = data.history;
  const item = data.item;
  const classyear = item?.classyear;
  const kelas = item?.kelas;
  const year = item?.year;
  const sem = item?.sem;

  function onDelete() {
    deleteRombel({ auth, history, id: classyear.id });
    closeModal();
  }

  return (
    <Modal closeModal={closeModal}>
      <div className='px-5'>
        <p className='has-text-info flex justify-start align-center is-size-5'>
          <span className='icon is-medium'>
            <Icon path={mdiShieldHalfFull} size={1} />
          </span>
          Konfirmasi
        </p>
        <p className='py-4 my-2 mx-2'>
          Apakah Anda yakin ingin menghapus rombel {' '}
          <span className='has-text-danger has-text-weight-semibold'>{`Kelas ${kelas}`}</span>{' '}(TA {year}{' - semester '}{sem})
          ? 
        </p>
        <div className='flex justify-end align-center pt-2'>
          <div className='buttons'>
            <Button
              cvariant='cdelete'
              withLabel={true}
              onClick={() => onDelete()}
            />
            <Button cvariant='cback' withLabel={true} onClick={closeModal} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteItem);
